import { Mail, ArrowUp } from "lucide-react";
import Logo from "./Logo";

export default function Footer({ onNavigate }) {
  const links = [
    { label: "Collection", href: "#collection" },
    { label: "Process", href: "#process" },
    { label: "Why Us", href: "#why-us" },
    { label: "Meet Ella", href: "#ella" },
    { label: "Order", href: "#order" },
  ];

  return (
    <footer className="relative bg-moss text-cream" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div>
            <div className="flex items-center gap-2.5">
              <Logo className="h-8 w-8" />
              <span className="font-serif font-semibold text-xl">Ella's Umbrellas</span>
            </div>
            <p className="mt-6 font-serif italic text-3xl sm:text-4xl tracking-tight max-w-sm" data-testid="footer-quote">
              Rain or shine, <span className="text-marigold">bloom anyway.</span>
            </p>
            <div className="mt-7 flex items-center gap-4">
              <a
                href="mailto:EllasUmbrellaAye@gmail.com"
                aria-label="Email"
                data-testid="footer-social-email"
                className="grid h-10 w-10 place-items-center rounded-full border border-cream/25 text-cream/80 transition-colors hover:bg-cream hover:text-moss"
              >
                <Mail size={17} />
              </a>
              <p className="font-mono text-[11px] uppercase tracking-wider text-cream/50">
                Write to Ella — she answers every note
              </p>
            </div>
          </div>

          <div className="flex gap-16 sm:gap-24">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-marigold">Wander</p>
              <ul className="mt-5 space-y-3">
                {links.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(" ", "-")}`}
                      onClick={(e) => {
                        e.preventDefault();
                        onNavigate(l.href);
                      }}
                      className="text-cream/75 hover:text-cream transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-marigold">Say hi</p>
              <ul className="mt-5 space-y-3 text-cream/75">
                <li data-testid="footer-email">
                  <a href="mailto:EllasUmbrellaAye@gmail.com" data-testid="footer-email-link" className="underline decoration-cream/30 underline-offset-4 hover:text-marigold transition-colors">
                    EllasUmbrellaAye@gmail.com
                  </a>
                </li>
                <li>Workshop: wherever the sun is</li>
                <li>Ella answers every note herself</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-t border-cream/15 pt-8">
          <p className="font-mono text-[11px] uppercase tracking-wider text-cream/60" data-testid="footer-copyright">
            © {new Date().getFullYear()} Ella's Umbrellas — all canopies hand-painted
          </p>
          <button
            data-testid="back-to-top-btn"
            onClick={() => onNavigate(0)}
            className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-5 py-2.5 text-sm font-semibold text-cream/85 transition-colors hover:bg-cream hover:text-moss"
          >
            Back to top
            <ArrowUp size={15} />
          </button>
        </div>
      </div>
    </footer>
  );
}
